/*********** DELIVERY SCROLL ***********/

$(document).ready(function ($) {
	$(".delivery-link a").click(function (e) {
		e.preventDefault();
		$("html, body").animate(
			{
				scrollTop: $(".delivery-info").offset().top,
			},
			1000,
		);
	});
});

/*********** FITTING BOX ***********/

/* n2Fv2anxIdXDJKTk9d9R3fjIIzpBT32eKmrj8wWT */

/**
 * custom.js (FittingBox hardened for Pacific theme + your modal snippet)
 * --------------------------------------------------------------------
 * Exposes window.* functions used by inline onclick handlers in Liquid:
 * - openModal(...)
 * - selectFrame(...)
 * - launchMsrt()
 * - closeMsrt()
 * - set_size()
 * - set_gender()
 * - getSnapshot()
 * - takeshot() / deleteshot() / share_image()
 *
 * Key fixes:
 * - Only create FitMix once the modal is visible and the container has size (prevents black screen).
 * - Safe wrapper for FitMix.createWidget signature differences.
 * - Ensure ALL close paths stopVto().
 * - PD Measurement widget only created when overlay is visible + container has size.
 */

(function () {
	"use strict";

	// -------------------------
	// Helpers
	// -------------------------
	function qs(sel, root) {
		return (root || document).querySelector(sel);
	}
	function toNumber(val) {
		const n = Number(val);
		return Number.isFinite(n) ? n : null;
	}
	function getRect(el) {
		try {
			return el ? el.getBoundingClientRect() : null;
		} catch (e) {
			return null;
		}
	}
	function hasUsableSize(el) {
		const r = getRect(el);
		return !!(r && r.width > 50 && r.height > 50);
	}
	function waitFor(conditionFn, { timeout = 6000, interval = 50 } = {}) {
		return new Promise((resolve, reject) => {
			const start = Date.now();
			const tick = () => {
				try {
					if (conditionFn()) return resolve(true);
				} catch (e) {}
				if (Date.now() - start > timeout)
					return reject(new Error("waitFor timeout"));
				setTimeout(tick, interval);
			};
			tick();
		});
	}

	// -------------------------
	// DOM refs
	// -------------------------
	const modal = document.getElementById("myModal");
	const closeBtn = modal ? modal.querySelector(".close") : null;

	// These exist inside your modal snippet
	const fitmixContainer = document.getElementById("fitmix-container");
	const msrtDiv = qs(".msrt-wrapper");
	const overlayDiv = qs(".overlay");
	const msrtContainer = document.getElementById("msrt-container");

	const pupilInput = document.getElementById("pupile");
	const snapshotImg = document.getElementById("my-snapshot");

	// -------------------------
	// State
	// -------------------------
	let fitmixInstance = null;
	let vtoReady = false;

	let msrtInstance = null;

	let fittingbox_frame = null;

	// kept for compatibility with your logic
	let shape_val;
	let colour_val;

	// -------------------------
	// FittingBox params
	// -------------------------
	const params = {
		apiKey: "n2Fv2anxIdXDJKTk9d9R3fjIIzpBT32eKmrj8wWT",
		onSnapshot: onSnapshot,
		onStopVto: () => {
			// do not reference undefined variables; close cleanly
			closeModal();
		},
	};

	// -------------------------
	// FitMix createWidget wrapper (signature-safe)
	// -------------------------
	function createFitmix(containerId, p, onReady) {
		if (
			typeof FitMix === "undefined" ||
			!FitMix ||
			typeof FitMix.createWidget !== "function"
		) {
			throw new Error(
				"FitMix not available. Check the FitMix script include in theme.liquid.",
			);
		}

		// Signature A: (containerId, params, cb)
		try {
			const instA = FitMix.createWidget(containerId, p, onReady);
			if (instA) return instA;
		} catch (e) {}

		// Signature B: (params, containerId, cb)
		try {
			const instB = FitMix.createWidget(p, containerId, onReady);
			if (instB) return instB;
		} catch (e) {}

		throw new Error(
			"FitMix.createWidget signature mismatch for your library build.",
		);
	}

	function ensureFitmixReady() {
		if (fitmixInstance) return;

		if (!fitmixContainer) {
			throw new Error("Missing #fitmix-container in DOM.");
		}

		vtoReady = false;

		fitmixInstance = createFitmix("fitmix-container", params, () => {
			vtoReady = true;
		});

		window.fitmixInstance = fitmixInstance;
	}

	async function startVtoLive() {
		ensureFitmixReady();

		await waitFor(() => {
			// modal visible + container sized + ready callback fired
			const modalVisible = modal
				? getComputedStyle(modal).display !== "none"
				: true;
			return modalVisible && hasUsableSize(fitmixContainer) && vtoReady;
		});

		fitmixInstance.startVto("live");
	}

	function stopVto() {
		try {
			fitmixInstance && fitmixInstance.stopVto();
		} catch (e) {}
	}

	// -------------------------
	// Modal open/close
	// -------------------------
	function openModalUI() {
		if (!modal) return;
		if (window.jQuery) {
			window.jQuery("#myModal").css("display", "block");
		} else {
			modal.style.display = "block";
		}
	}

	function closeModal() {
		stopVto();
		if (!modal) return;
		modal.style.display = "none";
	}

	if (closeBtn) closeBtn.addEventListener("click", closeModal);
	window.addEventListener("click", (event) => {
		if (!modal) return;
		if (event.target === modal) closeModal();
	});

	// -------------------------
	// Snapshot handling
	// -------------------------
	function onSnapshot(data) {
		if (!snapshotImg) return;

		if (window.jQuery) {
			window.jQuery("#my-snapshot").attr("src", data.dataURL).show();
			window.jQuery(".takeshot").show();
			window.jQuery(".snapshot").hide();
		} else {
			snapshotImg.src = data.dataURL;
			snapshotImg.style.display = "block";
		}
	}

	// Expose for your inline button:
	window.getSnapshot = function () {
		try {
			ensureFitmixReady();
			fitmixInstance.getSnapshot();
		} catch (e) {
			console.error("[FitMix] getSnapshot failed:", e);
		}
	};

	// -------------------------
	// Public: openModal(frame, handle, id, price, shape, colour)
	// Called elsewhere in theme
	// -------------------------
	window.openModal = function (frame, handle, id, price, shape, colour) {
		pushVtoEvent("vto_opened", {
			frame_sku: frame,
			product_handle: handle,
			product_id: id,
			product_price: price,
		});

		try {
			openModalUI();

			if (pupilInput) pupilInput.value = "";

			shape_val = (shape || "").substring(
				0,
				Math.max(0, (shape || "").length - 2),
			);
			colour_val = (colour || "").substring(
				0,
				Math.max(0, (colour || "").length - 2),
			);

			fittingbox_frame = frame;

			// Start VTO after modal visible, then select frame & update UI
			startVtoLive()
				.then(() => {
					window.selectFrame(frame, handle, id, price, shape, colour);
					console.log("VTO Frame ", frame);
				})
				.catch((e) => console.error("[FitMix] startVto failed:", e));
		} catch (e) {
			console.error("[FitMix] openModal error:", e);
		}
	};

	// -------------------------
	// Public: selectFrame(frameSku, handle, id, price, shape, colour)
	// Called from your carousel button onclick
	// -------------------------
	window.selectFrame = function (frame, handle, id, price, shape, colour) {
		pushVtoEvent("vto_frame_selected", {
			frame_sku: frame,
			product_handle: handle,
			product_id: id,
		});

		// keep your previous global usage
		window.form_id = id;

		// Normalize your "__" lists (you were trimming trailing "__")
		shape = (shape || "").substring(0, Math.max(0, shape.length - 2));
		colour = (colour || "").substring(0, Math.max(0, colour.length - 2));

		const shapeParts = shape ? shape.split("__") : [];
		const colourParts = colour ? colour.split("__") : [];

		if (window.jQuery) {
			// Show/hide the matching carousel buttons
			window.jQuery(".frame_button").hide();

			for (let i = 0; i < shapeParts.length; i++) {
				for (let j = 0; j < colourParts.length; j++) {
					window
						.jQuery(".frame_button." + shapeParts[i] + "." + colourParts[j])
						.show();
				}
			}

			// Update modal product info
			if (handle) {
				window.jQuery.getJSON(
					"/products/" + handle + ".js",
					function (product) {
						window.jQuery(".modal_col_left .page-title").html(product.title);
						window.jQuery(".modal_col_right .page-title").html(product.title);
						window
							.jQuery(".modal_col_right .product-price-minimum")
							.html(price);
						window
							.jQuery(".modal_col_right .vm-product-url")
							.attr("href", product.url);
						window
							.jQuery(".modal_col_right .vm-product-description")
							.html(product.description);
					},
				);
			}
		}

		// Set frame in FitMix
		try {
			fittingbox_frame = frame;
			ensureFitmixReady();
			fitmixInstance.setFrame(frame);
			console.log("VTO Frame ", frame);
		} catch (e) {
			console.error("[FitMix] setFrame failed:", e);
		}
	};

	// -------------------------
	// Public: set_size (PD)
	// -------------------------
	window.set_size = function (dist) {
		const pd = parseInt(dist, 10);
		if (!Number.isFinite(pd)) return;

		try {
			ensureFitmixReady();

			// Only update PD — avoid reloading the frame
			fitmixInstance.setPupillaryDistance(pd);

			// REMOVE this (it likely forces a reload / tracking reset)
			// if (fittingbox_frame) fitmixInstance.setFrame(fittingbox_frame);
		} catch (e) {
			console.error("[FitMix] set_size failed:", e);
		}

		if (window.jQuery) window.jQuery(".pp_dist").hide();
	};

	document.querySelectorAll(".pp_dist_toggle").forEach(function (btn) {
		btn.addEventListener("click", function () {
			const target = document.querySelector(".pp_dist");
			if (target) {
				target.style.display = "flex";
			}
		});
	});

	// -------------------------
	// Public: set_gender
	// -------------------------
	window.set_gender = function (gender) {
		try {
			ensureFitmixReady();
			fitmixInstance.setUserInfo({ gender: gender });
			if (fittingbox_frame) fitmixInstance.setFrame(fittingbox_frame);
		} catch (e) {
			console.error("[FitMix] set_gender failed:", e);
		}

		if (window.jQuery) window.jQuery(".pp_dist").hide();
	};

	// -------------------------
	// PD Measurement (Msrt) open/close
	// -------------------------
	window.closeMsrt = function () {
		if (msrtDiv) msrtDiv.style.display = "none";
		if (overlayDiv) overlayDiv.style.display = "none";
	};

	function ensureMsrtReady() {
		if (msrtInstance) return;

		if (!msrtContainer) {
			console.error("Missing #msrt-container");
			return;
		}

		if (
			typeof Msrt === "undefined" ||
			!Msrt ||
			typeof Msrt.createWidget !== "function"
		) {
			console.error(
				"Msrt not available. Check PD Measurement script include in theme.liquid.",
			);
			return;
		}

		msrtInstance = Msrt.createWidget("msrt-container", {
			...params,
			widgetUrl: "https://pd-measurement.fittingbox.com",
			onGetResultPd: (result) => {
				// Uncomment next line to discover payload shape if needed:
				// console.log("onGetResultPd:", result);

				const candidate =
					(result &&
						(result.pd ||
							result.PD ||
							result.pupillaryDistance ||
							result.value)) ??
					(result &&
						result.result &&
						(result.result.pd || result.result.pupillaryDistance));

				const pd = toNumber(candidate);
				if (pd == null) return;

				if (pupilInput) pupilInput.value = String(pd);

				try {
					ensureFitmixReady();
					fitmixInstance.setUserInfo({});
					fitmixInstance.setPupillaryDistance(pd);
					if (fittingbox_frame) fitmixInstance.setFrame(fittingbox_frame);
				} catch (e) {
					console.warn("[FitMix] Unable to apply PD result:", e);
				}

				window.closeMsrt();
			},
			onTooManyErrors: () => console.log("onTooManyErrors"),
			onClose: () => window.closeMsrt(),
		});
	}

	window.launchMsrt = function () {
		if (overlayDiv) overlayDiv.style.display = "block";
		if (msrtDiv) msrtDiv.style.display = "block";

		// allow layout to paint so container has size
		setTimeout(() => {
			if (msrtContainer && !hasUsableSize(msrtContainer)) {
				console.warn(
					"[Msrt] #msrt-container has no usable size. Add CSS height/min-height.",
					getRect(msrtContainer),
				);
			}
			ensureMsrtReady();
		}, 0);
	};

	// -------------------------
	// Watermark / Save / Delete / Share (your original logic, guarded)
	// -------------------------
	window.takeshot = function () {
		if (!window.jQuery) return;

		const img_src = window.jQuery("#my-snapshot").attr("src");
		const frames = window.jQuery("#page-title").html();

		if (!img_src || typeof watermark === "undefined") return;

		watermark([img_src])
			.image(
				watermark.text.upperLeft(
					"www.retropeepers.com",
					"30px PT Mono",
					"#9f0004",
					1,
					30,
					30,
				),
			)
			.render()
			.image(watermark.text.lowerRight(frames, "20px PT Mono", "#9f0004", 1))
			.then(function (img) {
				const a = document.createElement("a");
				a.href = img.src;
				a.download = String(frames || "snapshot").replace(/ /g, "_") + ".png";
				a.click();
			});

		window.jQuery("#my-snapshot").attr("src", "").hide();
		window.jQuery(".takeshot").hide();
		window.jQuery(".snapshot").show();
	};

	window.deleteshot = function () {
		if (!window.jQuery) return;
		window.jQuery("#my-snapshot").attr("src", "").hide();
		window.jQuery(".takeshot").hide();
		window.jQuery(".snapshot").show();
	};

	window.share_image = function () {
		if (!window.jQuery) return;

		const img_src = window.jQuery("#my-snapshot").attr("src");
		const frames = window.jQuery("#page-title").html();

		if (!img_src || typeof watermark === "undefined") return;

		watermark([img_src])
			.image(
				watermark.text.upperLeft(
					"https://retropeepers.com",
					"24px PT Mono",
					"#000000",
					0.8,
				),
			)
			.render()
			.image(watermark.text.lowerRight(frames, "14px PT Mono", "#000000", 0.8))
			.then(function (img) {
				const a = document.createElement("a");
				a.href = img.src;
				a.download = String(frames || "snapshot").replace(/ /g, "_") + ".png";

				const u = a.download;
				const t = frames;

				window.open(
					"http://www.facebook.com/sharer.php?u=" +
						encodeURIComponent(u) +
						"&t=" +
						encodeURIComponent(t),
					"sharer",
					"toolbar=0,status=0,width=626,height=436",
				);
				return false;
			});
	};

	// -------------------------
	// Collection filtering logic (kept as-is, but not polled)
	// -------------------------
	function initJqueryBits($) {
		$(".vm_active").show();

		let results = [];
		const fallbackURL = $(".collection-filtering").data("fallback-url");

		$(".collection-filtering select").on("change", function () {
			changeFilter();
			updateFilter($(this));
		});

		$(".collection-remove-filter").on("click", function () {
			resetFilter();
		});

		function changeFilter() {
			let filter, j, len, selectedText;
			const ref1 = $(".collection-filter select");
			results = [];
			for (j = 0, len = ref1.length; j < len; j++) {
				filter = ref1[j];
				if ($(filter).val() !== "any") {
					selectedText = $(filter).find("option:selected").text();
					results.push($(filter).prev().find("strong").text(selectedText));
				} else {
					results.push(void 0);
				}
			}
		}

		function updateFilter(e) {
			let filter, filterURL, j, len, newTags, ref1, tag, tags;
			newTags = [];
			e.toggleClass("active");
			ref1 = $(".collection-filter select");
			for (j = 0, len = ref1.length; j < len; j++) {
				filter = ref1[j];
				if ($(filter).val() !== "any") {
					tag = $(filter).val();
					newTags.push(tag);
				}
			}
			if (newTags.length) {
				tags = newTags.join("+");
				filterURL = fallbackURL + "/" + tags;

				if (window.location.href.indexOf("?&sort_by=") > -1) {
					window.location.href =
						filterURL + "?&sort_by=" + $(".collection-sorting select").val();
				} else {
					window.location.href = filterURL;
				}
			} else {
				resetFilter();
			}
		}

		function resetFilter() {
			const fallback = "" + fallbackURL;
			if (window.location.href.indexOf("?&sort_by=") > -1) {
				window.location.href =
					fallback + "?&sort_by=" + $(".collection-sorting select").val();
			} else {
				window.location.href = fallback;
			}
		}

		changeFilter();
	}

	if (window.jQuery) {
		window.jQuery(function ($) {
			initJqueryBits($);
		});
	}
})();

/*********** OMNISEND RATINGS ***********/

function omnisendHide() {
	console.log("loaded");

	var reviewElement = document.querySelector(
		".omnisend-main-review-block-average-rating-description",
	);

	if (!reviewElement) {
		return;
	}

	console.log("reviewElement.innerText " + reviewElement.innerText);

	if (reviewElement.innerText === "Based on 0 reviews") {
		document.getElementById("omnisend-reviews-block").style.display = "none";
	}
}

setTimeout(() => {
	omnisendHide();
}, "1000");

/*********** GOOGLE TAG HELPER ***********/

function pushVtoEvent(eventName, payload = {}) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		...payload,
	});
}
